import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Button from "components/CustomButtons/Button.jsx";
import { API } from 'aws-amplify';
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import courseDetailsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/courseDetailsStyle.jsx";

class CourseEnrolSection extends React.Component {

  state = {
    formData: {
      iteration: "",
      firstname: "",
      lastname: "",
      city: "",
      country: "",
      job: "",
      bu: "",
      email: "",
      confirmemail: ""
    },
    showForm: false,
    submitted: false,
    showCongratulations: false,
    showFailure: false
  };

  componentDidMount() {
    // custom rule will have name 'isEmailMatch'
    ValidatorForm.addValidationRule("isEmailMatch", value => {
      if (value !== this.state.formData.email) {
        return false;
      }
      return true;
    });
  }

  handleChange = event => {
    const { formData } = this.state;
    formData[event.target.name] = event.target.value;
    this.setState({ formData });
  };

  handleSubmit = () => {
    this.setState({ submitted: true }, () => {
      this.postData()
        .then(response => {
          console.log("postData", response);
          this.setState({ showForm: false });
          this.setState({ showCongratulations: true });
        })
        .catch(error => {
          console.log("Error", error);
          this.setState({ showFailure: true });
        });
      // setTimeout(() => this.setState({ submitted: false }), 5000);
    });
  };

  handleSessionChoice = (id, event) => {
    const { formData } = this.state;
    formData["iteration"] = id;
    this.setState({ formData });
    this.setState({ showForm: true });
  };

  async postData() {
    const { courseiteration } = this.props;
    const myiteration = courseiteration.find(item => item.sd === this.state.formData.iteration)
    let apiName = 'capabilityexplorer';
    let path = '/course/' + myiteration.id + '/iteration/' + this.state.formData.iteration + "/register";
    let myInit = { // OPTIONAL
      body: this.state.formData,
      headers: {} // OPTIONAL
    };
    return await API.post(apiName, path, myInit);
  }

  render() {
    const { classes, courseiteration, sessionsData, ...rest } = this.props;
    const {
      formData,
      submitted,
      showForm,
      showCongratulations,
      showFailure
    } = this.state;

    const now = new Date();
    const sessions = courseiteration.map(iteration => {
      const sessiondate = new Date(iteration.sd);
      const disabled = now > sessiondate ? true : false;

      return (
        <GridItem key={iteration.sd} xs={12} sm={6} md={3} lg={2}>
          <Button
            id={iteration.sd}
            color={
              this.state.formData.iteration === iteration.sd && !disabled
                ? "rose"
                : "primary"
            }
            disabled={disabled}
            onClick={e => this.handleSessionChoice(iteration.sd, e)}
          >
            {sessiondate.toDateString()}
          </Button>
        </GridItem>
      );
    });

    const failureBlock = (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8} lg={8}>
          <h4>Upcoming sessions to be confirmed.</h4>
        </GridItem>
      </GridContainer>
    );

    const congratsBlock = (
      <GridContainer justify="center">
        <GridItem xs={12} sm={12} md={8} lg={8}>
          <h4>
            Thanks for registering! You will receive a confirmation email
            shortly.
          </h4>
          <h5>
            Please check your spam or junk mail folder if you do not receive the
            confirmation message within a few minutes of signing up.
          </h5>
        </GridItem>
      </GridContainer>
    );

    const formBlock = (
      <GridContainer id="registrationform" justify="center">
        <GridItem xs={12} sm={12} md={8} lg={8}>
          <h5>2 - Complete the form</h5>
        </GridItem>
        <GridItem xs={12} sm={12} md={8} lg={8}>
          <ValidatorForm ref="form" onSubmit={this.handleSubmit}>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <TextValidator
                fullWidth
                label="First Name"
                onChange={this.handleChange}
                name="firstname"
                value={formData.firstname}
                validators={['required']}
                errorMessages={['this field is required']}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <TextValidator
                fullWidth
                label="Last Name"
                onChange={this.handleChange}
                name="lastname"
                value={formData.lastname}
                validators={['required']}
                errorMessages={['this field is required']}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <TextValidator
                fullWidth
                label="City"
                onChange={this.handleChange}
                name="city"
                value={formData.city}
                validators={['required']}
                errorMessages={['this field is required']}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <TextValidator
                fullWidth
                label="Country"
                onChange={this.handleChange}
                name="country"
                value={formData.country}
                validators={['required']}
                errorMessages={['this field is required']}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <TextValidator
                fullWidth
                label="Job Title"
                onChange={this.handleChange}
                name="job"
                value={formData.job}
                validators={['required']}
                errorMessages={['this field is required']}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <TextValidator
                fullWidth
                label="College/Centre"
                onChange={this.handleChange}
                name="bu"
                value={formData.bu}
                validators={['required']}
                errorMessages={['this field is required']}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <TextValidator
                fullWidth
                label="Email"
                onChange={this.handleChange}
                name="email"
                value={formData.email}
                validators={['required', 'isEmail']}
                errorMessages={['this field is required', 'email is not valid']}
              />
            </GridItem>
            <GridItem xs={12} sm={12} md={12} lg={12}>
              <TextValidator
                fullWidth
                label="Confirm email"
                onChange={this.handleChange}
                name="confirmemail"
                value={formData.confirmemail}
                validators={['isEmailMatch','required']}
                errorMessages={['Email Mistmach','this field is required']}
              />
            </GridItem>
            <GridItem xs={6} sm={6} md={6} lg={6}>
              <Button
                fullWidth
                color="primary"
                variant="contained"
                type="submit"
                disabled={submitted}
              >
                {(submitted && "Your form is submitted!") ||
                  (!submitted && "Register")}
              </Button>
            </GridItem>
          </ValidatorForm>
        </GridItem>
      </GridContainer>
    );

    console.log("sessionsData", sessionsData, "courseiteration.length",courseiteration.length)

    return (
      <div className="cd-section" {...rest}>
        <div className={classes.blog}>
          {/* If data have been received */}
          {sessionsData && courseiteration.length ? (
            <div className={classes.container}>
              <GridContainer justify="center">
              <GridItem xs={12} sm={12} md={8} lg={8}>
                <h3>TO REGISTER</h3>
                <h5>1 - Select a session</h5>
              </GridItem>
            </GridContainer>
              <GridContainer justify="center">{sessions}</GridContainer>
              {showForm && formBlock}
              {showCongratulations && congratsBlock}
              {showFailure && failureBlock}
            </div>
          ) : (
            <div className={classes.container}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8} lg={8}>
                  Sorry no session at the moment
                </GridItem>
              </GridContainer>
            </div>
          )}
        </div>
      </div>
    );
  }
}

export default withStyles(courseDetailsStyle)(CourseEnrolSection);
